// moment をグローバル公開する(Sprockets 時代と同じ挙動)。
// datetimepicker / daterangepicker は CommonJS 経由で moment を解決するが、
// グローバル moment に依存するコードのために window にも公開しておく。
import moment from "moment";

window.moment = moment;
